import styled from "styled-components"

export default styled.div`
  width: 35rem;
  max-height: 10rem;
  overflow: hidden;
  padding: 1rem;
  
  & .wrapper{
    transform: rotate(-90deg) translateY(11.5rem) translateX(17rem);
    max-width: 11rem;
  } 
  
  & .timeline-text{
    transform: rotate(90deg);
    max-width: 10rem;
    text-align: left;
    font-size: 1rem;
  }
`
